import React from 'react'
import useTransferList from '../../hooks/useTransferList'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

const Greeting = () => {
  const futureTransfers = useTransferList('future')
  const user = useSelector((state: RootState) => state.app.user)

  return (
    <div className="row">
      <div className="col-12">
        <h1>{user === undefined ? 'Hello!' : `Hello ${user?.first_name || 'guest'}!`}</h1>
        {user !== undefined && (
          <>
            {futureTransfers.isLoading ? (
              <p>Loading transfers...</p>
            ) : (
              <p>You have {futureTransfers.response.transfers.length} upcoming transfers</p>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default Greeting
